<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
<!--      <div class="row" style="width:800px">-->
<!--        <div class="col-3" v-if="currentFilterGroup1 !==''">-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2()">全部</a>-->
<!--        </div>-->
<!--        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup2(currentFilterGroup1)" :key="index" >-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2(item)">{{item}}</a>-->
<!--        </div>-->
<!--      </div>-->

    <hr>

    <a class="btn btn-primary" @click="DataItemMaster_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain" style="width:1000px">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
<!--        <th>Tag</th>-->
        <th>標題</th>
        <th>內容</th>
        <th>超連結</th>
        <th>狀態</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in datas" :key="index">
          <td class="text-center" width="280px">
<!--            <a class="btn btn-primary" @click="DataItemMaster_Insert(item)"><i class="fas fa-plus-circle"></i></a>-->
            <a class="btn btn-danger" @click="DataItemMaster_Remove(item)"><i class="far fa-trash-alt"></i></a>
<!--            <a class="btn btn-primary" @click="DataItemMaster_MoveUp(item)"><i class="fa fa-angle-up"></i> </a>-->
<!--            <a class="btn btn-primary" @click="DataItemMaster_MoveDown(item)"><i class="fa fa-angle-down"></i> </a>-->
          </td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.Title"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.Content"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.HyperLink"></td>
          <td>
            <select class="form-control" v-model="item.IsEnable">
              <option :value="false">停用</option>
              <option :value="true">啟用</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>

<!--    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />-->
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

export default {
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{
      },
    };
  },
  methods: {
    loadData() {
      let that=this;
      let loader=util.ShowLoading(this);
      apiAdmin.api_getContent(this.$u.TzsciQueryType_News).then((data)=>{
        let dataApi=apiAdmin.init(data.data.data);

        that.datas=dataApi;
        util.HideLoading(loader);
        // that.$nextTick(() => { //with this we skip the first change
        //   that.isLoaded = true
        // })
      })
    },
    submit(){
      apiAdmin.api_saveContent(this.$u.TzsciQueryType_News,this.datas).then(()=>{
        alert('儲存成功')
      })
    },

    DataItemMaster_MoveUp(item) {
      arrayUtil.orderMove(false, item.SystemId, this.datas, "SystemId", "OrderKey")
    },
    DataItemMaster_MoveDown(item) {
      arrayUtil.orderMove(true, item.SystemId, this.datas, "SystemId", "OrderKey")
    },
    DataItemMaster_AddLast() {
      let newItem = {
        SystemId: "",
        OrderKey: "",
        Title: "",
        Content: "",
        HyperLink:"",
        IsEnable:false,
      };
      newItem.SystemId = util.uuid();

      arrayUtil.orderAppendLast(newItem, this.datas, "OrderKey")
    },
    DataItemMaster_Insert(currentItem){

      let newItem =          {
            SystemId: "",
            OrderKey: "",
            Title: "",
            Content: "",
            HyperLink:"",
            IsEnable:false,
          };
      newItem.SystemId = util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.datas,"SystemId","OrderKey")
    },
    DataItemMaster_Remove(item) {
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },

    // editHtmlContent(item){
    //   this.$refs.dlgEditor.callbackItem=item;
    //   this.$refs.dlgEditor.htmlContent=item.HtmlContent;
    //   this.$refs.dlgEditor.showModal();
    // },
    // dlgEditorReturnOK(item){
    //   item.HtmlContent=this.$refs.dlgEditor.htmlContent;
    // }
  },
  mounted() {
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1300px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
.filterItembutton{
  color: white !important;
  width: 220px;
}
.abutton{
  color: white !important;
}
.btn{
  color: white !important;
  margin: 5px;
}
</style>
